import React from "react";

function HeaderComponent(props) {
    return (
        <div id={props.title} className="blue-header">{props.title}</div>
    )
}

export default HeaderComponent;
